<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <router-link
              :to="{
                            name: 'fieldStore', 
                            params: {product_id: $route.params.product_id}
                            }"
              class="btn btn-success"
            >Добавить свойства</router-link>
            <h4 class="pull-right">Свойства</h4>
          </header>
          <div class="card-body">
            <table class="table table-bordered table-striped" id="serverDataTable">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>labelRus</th>
                  <!-- <th>labelUzl</th>
                  <th>labelUzk</th> -->
                  <th>Подсказка | comment</th>
                  <th>Тип поля | inputType</th>
                  <th>Обязательное поля | isRequired</th>
                  <th>action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(field, index) in fields" :key="index">
                  <td>{{ field.id }}</td>
                  <td>{{ field.labelRus }}</td>
                  <!-- <td>{{ field.labelUzl }}</td>
                  <td>{{ field.labelUzk }}</td>-->
                  <td>{{ field.comment }}</td>
                  <td>
                    {{ field.inputType }} <br>
                    <span v-for="(value, index) in field.values" :key="value.id">
                      {{ field.values[index] }} |
                    </span>

                  </td>
                  <td>{{ field.isRequired == 1 ? "true" : "false" }}</td>
                  <td>
                    <a
                      href="javascript:void(0);"
                      @click="deleteField(field.id)"
                      class="btn btn-danger"
                    >Удалить</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, DELETE } from "../../shared/api";
export default {
  data() {
    return {
      fields: []
    };
  },
  methods: {
    getFields() {
      GET(
        [],
        "/productFields/" + this.$route.params.product_id,
        this,
        false
      ).then(response => {
        this.fields = response.fields;
      });
    },
    deleteField(id) {
      DELETE(id, "/field/", this).then(response => {
        this.getFields();
      });
    }
  },
  mounted() {
    this.getFields();
  }
};
</script>
